import { SxProps, Theme } from '@mui/material';

export const backdrop: SxProps<Theme> = {
  color: (theme) => theme.palette.common.white,
  zIndex: (theme) => theme.zIndex.drawer + 1,
};
